module.exports = __webpack_public_path__ + "media/images/news-big-d8fcf24d816c0847ecce25f08e58996e.jpg";